import { createContext, ReactNode } from 'react';

import { Container } from 'inversify';

export const IocContext = createContext<Container | null>(null);

type IocProviderProps = {
  container: Container;
  children: ReactNode | ReactNode[];
};

export const IocProvider = ({ container, children }: IocProviderProps) => {
  return (
    <IocContext.Provider value={container}>{children}</IocContext.Provider>
  );
};
